const SUPPORTED_TLDS = ['de', 'at', 'ch', 'fr', 'nl', 'be', 'it', 'es'] as const
type SupportedTLDTuple = typeof SUPPORTED_TLDS
export type SupportedTLD = SupportedTLDTuple[number]

export const isSupportedTLD = (tld?: string): tld is SupportedTLD => {
  return SUPPORTED_TLDS.includes(tld as SupportedTLD)
}
